import * as React from "react";
import type { SVGProps } from "react";
const SvgTemperature04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 17.4h.056m4.144 0a4.2 4.2 0 1 1-6.6-3.447V4.798a2.4 2.4 0 0 1 4.8.002v9.153c.86.769 1.8 2.203 1.8 3.447"
    />
  </svg>
);
export default SvgTemperature04;
